import { jsx as _jsx } from "react/jsx-runtime";
import localeTranslator from 'library/Hocs/LocalTranslator';
import { FormSelect } from 'components/AntEnhancement/FormControls';
import services from 'services';
var OrderEntities = function (props) {
    var orderEntityService = services.orderEntityService;
    var orderEntities = orderEntityService.useOrderEntities({ is_enabled: true }).data;
    var onChangeEntity = function (value) { return props.package.setEntityId(Number(value)); };
    var getOrderEntities = function () {
        return (orderEntities === null || orderEntities === void 0 ? void 0 : orderEntities.map(function (orderEntity) { return ({
            value: orderEntity.getId(),
            title: orderEntity.getName()
        }); })) || [];
    };
    return (_jsx(FormSelect, { label: props.packageElementTitle, name: "packageElementTitle", formClasses: "pkg-form__item", rules: [
            { required: true, message: props.translate("errors.".concat(props.packageElementTitle)) }
        ], placeHolder: props.packageElementTitle, onSelect: onChangeEntity, options: getOrderEntities() }));
};
export default localeTranslator(OrderEntities, 'newPackage');
